import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";
import {
    faAnglesRight,
    faBaby,
    faBell,
    faBowlFood,
    faBucket,
    faBurger,
    faWarning,
    faDatabase,
    faDroplet,
    faEye,
    faFileExcel,
    faFillDrip,
    faFilter,
    faFlaskVial,
    faGear,
    faGlassWaterDroplet,
    faHouseFloodWaterCircleArrowRight,
    faInbox,
    faLineChart,
    faListCheck,
    faLocationDot,
    faMicroscope,
    faShrimp,
    faUsers,
    faWater,
    faWeightScale,
    faAdd,
    faCubesStacked,
    faRulerVertical,
    faHighlighter,
    faBoxArchive,
    faSnowflake,
    faTrash,
    faRuler,
    faBalanceScale,
    faClipboardCheck,
    faCheck,
    faBlog,
    faDashboard,
    faToolbox,
    faBoxesPacking,
    faBullseye,
    faBroom,
    faPrescriptionBottleMedical,
    faTableColumns,
    faFeather,
    faComment,
    faDolly,
    faTruckRampBox,
    faBoxesStacked
} from "@fortawesome/free-solid-svg-icons";

export interface Model {
    routes?: {
        admin?: {
            list: string,
            edit: string,
            new: string,
        },
        site?: {
            list: string,
            new?: string,
            page?: string,
        },
        tank?: {
            list: string,
            new?: string,
        },
        batch?: {
            list: string,
            new?: string,
        },
    }
    model: string,
    group: string,
    label: string,
    foreignKey?: string,
    nameKey?: string,
    icon: IconProp,
    index: number
}
export const MODELS_OBJECT: { [modelName: string]: Model } = {
    "BatchAcclimatization": {
        routes: {
            admin: {
                list: "adminBatchAcclimatizations",
                edit: "adminBatchAcclimatization",
                new: "adminNewBatchAcclimatization",
            },
            site: {
                list: "batchAcclimatization",
                new: "newBatchAcclimatization",
            },
            tank: {
                new: "batchAcclimatization",
                list: "batchAcclimatizations",
            },
        },
        model: "BatchAcclimatization",
        label: "batchAcclimatization",
        icon: faHouseFloodWaterCircleArrowRight,
        group: "batch",
        index: 20
    },
    "Batch": {
        routes: {
            admin: {
                list: "adminBatches",
                edit: "adminBatch",
                new: "adminNewBatch",
            },
            site: {
                list: "batches",
            },
            tank: {
                list: "batches",
            },
        },
        model: "Batch",
        label: "batch",
        foreignKey: "idBatch",
        icon: faShrimp,
        group: "batch",
        index: 1
    },
    "BatchInitial": {
        routes: {
            admin: {
                list: "adminBatchInitials",
                edit: "adminBatchInitial",
                new: "adminNewBatchInitial",
            },
            site: {
                list: "batchInitials",
                new: "batchInitial",
            },
            tank: {
                list: "batchInitials",
            },
        },
        model: "BatchInitial",
        label: "batchInitial",
        icon: faDolly,
        group: "batch",
        index: 0
    },
    "BatchTransfer": {
        routes: {
            admin: {
                list: "adminBatchTransfers",
                edit: "adminBatchTransfer",
                new: "adminNewBatchTransfer",
            },
            site: {
                list: "siteBatchTransfer",
            },
            tank: {
                list: "batchTransfer",
            },
        },
        model: "BatchTransfer",
        label: "batchTransfer",
        icon: faAnglesRight,
        group: "batch",
        index: 2
    },
    "BatchProduction": {
        routes: {
            admin: {
                list: "adminBatchProductions",
                edit: "adminBatchProduction",
                new: "adminNewBatchProduction",
            },
            site: {
                list: "batchProductions",
            },
            tank: {
                list: "batchProductions",
            },
        },
        model: "BatchProduction",
        label: "batchProduction",
        icon: faDatabase,
        group: "batch",
        index: 2
    },
    "BatchProductionAIRequest": {
        routes: {
            admin: {
                list: "adminBatchProductionAIRequests",
                edit: "adminBatchProductionAIRequest",
                new: "adminNewBatchProductionAIRequest",
            },
            site: {
                list: "batchProductionAIRequests",
            },
            tank: {
                list: "batchProductionAIRequests",
            },
        },
        model: "BatchProductionAIRequest",
        label: "batchProductionAIRequest",
        icon: faDatabase,
        group: "batch",
        index: 40
    },
    "BatchReport": {
        routes: {
            admin: {
                list: "adminBatchReports",
                edit: "adminBatchReport",
                new: "adminNewBatchReport",
            },
            site: {
                list: "batchReport",
            },
            tank: {
                list: "batchReport",
            },
        },
        model: "BatchReport",
        label: "batchReport",
        icon: faListCheck,
        group: "batch",
        index: 2
    },
    "BatchReportTarget": {
        routes: {
            admin: {
                list: "adminBatchReportTargets",
                edit: "adminBatchReportTarget",
                new: "adminNewBatchReportTarget",
            },
            site: {
                list: "batchReportTarget",
            },
            tank: {
                list: "batchReportTarget",
            },
        },
        model: "BatchReportTarget",
        label: "batchReportTarget",
        icon: faBullseye,
        group: "batch",
        index: 2
    },
    "BatchAnalysis": {
        routes: {
            site: {
                list: "batchAnalysis",
            },
            batch: {
                list: "batchAnalysis",
            },
        },
        model: "BatchAnalysis",
        label: "batchAnalysis",
        icon: faDashboard,
        group: "batch",
        index: 2
    },
    "Event": {
        routes: {
            admin: {
                list: "adminEvents",
                edit: "adminEvent",
                new: "adminNewEvent",
            },
            site: {
                list: "siteEvents",
            },
            tank: {
                list: "events",
                new: "events",
            },
        },
        model: "Event",
        label: "event",
        icon: faWarning,
        group: "event",
        index: 9
    },
    "EventCriticality": {
        routes: {
            admin: {
                list: "adminEventCriticalities",
                edit: "adminEventCriticality",
                new: "adminNewEventCriticality",
            },
            site: {
                list: "eventCriticalities",
            },
            tank: {
                list: "eventCriticalities",
            },
        },
        model: "EventCriticality",
        label: "eventCriticality",
        foreignKey: "idCriticality",
        icon: faGear,
        group: "event",
        index: 11
    },
    "EventType": {
        routes: {
            admin: {
                list: "adminEventTypes",
                edit: "adminEventType",
                new: "adminNewEventType",
            },
            site: {
                list: "eventTypes",
            },
            tank: {
                list: "eventTypes",
            },
        },
        model: "EventType",
        label: "eventType",
        foreignKey: "idType",
        icon: faGear,
        group: "event",
        index: 12
    },
    "Feeding": {
        routes: {
            admin: {
                list: "adminFeedings",
                edit: "adminFeeding",
                new: "adminNewFeeding",
            },
            site: {
                list: "feeding",
            },
            tank: {
                list: "feeding",
                new: "feeding",
            },
        },
        model: "Feeding",
        label: "feeding",
        icon: faCubesStacked,
        group: "action",
        index: 0
    },
    "GrowModel": {
        routes: {
            admin: {
                list: "adminGrowModels",
                edit: "adminGrowModel",
                new: "adminNewGrowModel",
            },
            site: {
                list: "growModels",
            },
            tank: {
                list: "growModels",
            },
        },
        model: "GrowModel",
        label: "growModel",
        icon: faLineChart,
        group: "growModel",
        index: 8
    },
    "GrowModelValue": {
        routes: {
            admin: {
                list: "adminGrowModels",
                edit: "adminGrowModel",
                new: "adminNewGrowModel",
            },
            site: {
                list: "growModels",
            },
            tank: {
                list: "growModels",
            },
        },
        model: "GrowModelValues",
        nameKey: "stadePL",
        label: "growModelValues",
        icon: faLineChart,
        group: "growModel",
        index: 8
    },
    "Profile": {
        routes: {
            admin: {
                list: "adminProfiles",
                edit: "adminProfile",
                new: "adminNewProfile",
            },
            site: {
                list: "profiles",
            },
            tank: {
                list: "profiles",
            },
        },
        model: "Profile",
        label: "profile",
        foreignKey: "createdBy",
        nameKey: "fullName",
        icon: faUsers,
        group: "profile",
        index: 10
    },
    "Review": {
        routes: {
            admin: {
                list: "adminReviews",
                edit: "adminReview",
                new: "adminNewReview",
            },
        },
        model: "Review",
        label: "review",
        icon: faFeather,
        group: "records",
        index: 12
    },
    "ReviewComment": {
        routes: {
            admin: {
                list: "adminReviewComments",
                edit: "adminReviewComment",
                new: "adminNewReviewComment",
            },
        },
        model: "ReviewComment",
        label: "reviewComment",
        icon: faComment,
        group: "records",
        index: 12
    },
    "ProfileRole": {
        model: "ProfileRole",
        label: "profileRole",
        foreignKey: "createdBy",
        nameKey: "fullName",
        icon: faUsers,
        group: "profile",
        index: 10
    },
    "Role": {
        routes: {
            admin: {
                list: "adminRoles",
                edit: "adminRole",
                new: "adminNewRole",
            },
        },
        model: "Role",
        label: "role",
        foreignKey: "idRole",
        nameKey: "name",
        icon: faGear,
        group: "profile",
        index: 11
    },
    "Provider": {
        routes: {
            admin: {
                list: "adminProviders",
                edit: "adminProvider",
                new: "adminNewProvider",
            },
            site: {
                list: "providers",
            },
            tank: {
                list: "providers",
            },
        },
        model: "Provider",
        label: "provider",
        icon: faBaby,
        group: "configuration",
        index: 12
    },
    "Site": {
        routes: {
            admin: {
                list: "adminSites",
                edit: "adminSite",
                new: "adminNewSite",
            },
            site: {
                list: "sites",
                page: "site",
            },
            tank: {
                list: "sites",
            },
        },
        model: "Site",
        label: "site",
        icon: faLocationDot,
        group: "configuration",
        index: 7
    },
    "Tank": {
        routes: {
            admin: {
                list: "adminTanks",
                edit: "adminTank",
                new: "adminNewTank",
            },
            site: {
                list: "tanks",
            },
            tank: {
                list: "tanks",
            },
        },
        model: "Tank",
        label: "tank",
        foreignKey: "idTank",
        icon: faInbox,
        group: "configuration",
        index: 5
    },
    "TankType": {
        routes: {
            admin: {
                list: "adminTankTypes",
                edit: "adminTankType",
                new: "adminNewTankType",
            },
            site: {
                list: "tankTypes",
            },
            tank: {
                list: "tankTypes",
            },
        },
        model: "TankType",
        label: "tankType",
        foreignKey: "tank_type",
        icon: faGear,
        group: "configuration",
        index: 13
    },
    "Water": {
        routes: {
            admin: {
                list: "adminWaters",
                edit: "adminWater",
                new: "adminNewWater",
            },
            site: {
                list: "waters",
            },
            tank: {
                list: "waters",
            },
        },
        model: "Water",
        label: "water",
        foreignKey: "idWater",
        icon: faWater,
        group: "configuration",
        index: 3
    },
    "WaterTransfer": {
        routes: {
            admin: {
                list: "adminWaterTransfers",
                edit: "adminWaterTransfer",
                new: "adminNewWaterTransfer",
            },
            site: {
                list: "waterTransfers",
            },
            tank: {
                list: "waterTransfers",
            },
        },
        model: "WaterTransfer",
        label: "waterTransfer",
        icon: faAnglesRight,
        group: "action",
        index: 4
    },
    "BiometricAnalysis": {
        routes: {
            admin: {
                list: "adminBiometricAnalyses",
                edit: "adminBiometricAnalysis",
                new: "adminNewBiometricAnalysis",
            },
            site: {
                list: "biometricAnalyses",
            },
            tank: {
                list: "biometricAnalyses",
                new: "biometricAnalysis",
            },
        },
        model: "BiometricAnalysis",
        label: "biometricAnalysis",
        icon: faWeightScale,
        group: "records",
        index: 14
    },
    "MicrobiologicalAnalysis": {
        routes: {
            admin: {
                list: "adminMicrobiologicalAnalyses",
                edit: "adminMicrobiologicalAnalysis",
                new: "adminNewMicrobiologicalAnalysis",
            },
            site: {
                list: "microbiologicalAnalyses",
            },
            tank: {
                list: "microbiologicalAnalyses",
                new: "microbiologicalAnalysis",
            },
        },
        model: "MicrobiologicalAnalysis",
        label: "microbiologicalAnalysis",
        icon: faMicroscope,
        group: "records",
        index: 16
    },
    "ObservationalAnalysis": {
        routes: {
            admin: {
                list: "adminObservationalAnalyses",
                edit: "adminObservationalAnalysis",
                new: "adminNewObservationalAnalysis",
            },
            site: {
                list: "observationalAnalyses",
            },
            tank: {
                list: "observationalAnalyses",
                new: "observationalAnalysis",
            },
        },
        model: "ObservationalAnalysis",
        label: "observationalAnalysis",
        icon: faEye,
        group: "records",
        index: 17
    },
    "PhysicochemicalAnalysis": {
        routes: {
            admin: {
                list: "adminPhysicochemicalAnalyses",
                edit: "adminPhysicochemicalAnalysis",
                new: "adminNewPhysicochemicalAnalysis",
            },
            site: {
                list: "physicochemicalAnalyses",
            },
            tank: {
                list: "physicochemicalAnalysis",
                new: "physicochemicalAnalysis",
            },
        },
        model: "PhysicochemicalAnalysis",
        label: "physicochemicalAnalysis",
        icon: faFlaskVial,
        group: "records",
        index: 18
    },
    "Seeding": {
        routes: {
            admin: {
                list: "adminSeedings",
                edit: "adminSeeding",
                new: "adminNewSeeding",
            },
            site: {
                list: "seedings",
            },
            tank: {
                list: "seedings",
                new: "seeding",
            },
        },
        model: "Seeding",
        label: "seeding",
        icon: faFillDrip,
        group: "action",
        index: 19
    },
    "Settling": {
        routes: {
            admin: {
                list: "adminSettlings",
                edit: "adminSettling",
                new: "adminNewSettling",
            },
            site: {
                list: "settlings",
            },
            tank: {
                list: "settlings",
                new: "settling",
            },
        },
        model: "Settling",
        label: "settling",
        icon: faFilter,
        group: "action",
        index: 20
    },
    "Knackery": {
        routes: {
            admin: {
                list: "adminKnackeries",
                edit: "adminKnackery",
                new: "adminNewKnackery",
            },
            site: {
                list: "knackeries",
            },
            tank: {
                list: "knackeries",
                new: "knackery",
            },
        },
        model: "Knackery",
        label: "knackery",
        icon: faBroom,
        group: "action",
        index: 20
    },
    "WaterAnalysis": {
        routes: {
            admin: {
                list: "adminWaterAnalyses",
                edit: "adminWaterAnalysis",
                new: "adminNewWaterAnalysis",
            },
            site: {
                list: "waterAnalyses",
            },
            tank: {
                list: "waterAnalyses",
                new: "waterAnalysis",
            },
        },
        model: "WaterAnalysis",
        label: "waterAnalysis",
        icon: faDroplet,
        group: "records",
        index: 21
    },
    "WaterBalance": {
        routes: {
            admin: {
                list: "adminWaterBalances",
                edit: "adminWaterBalance",
                new: "adminNewWaterBalance",
            },
            site: {
                list: "waterBalances",
            },
            tank: {
                list: "waterBalances",
                new: "waterBalance",
            },
        },
        model: "WaterBalance",
        label: "waterBalance",
        icon: faGlassWaterDroplet,
        group: "action",
        index: 21
    },
    "FoodMix": {
        routes: {
            admin: {
                list: "adminFoodMixes",
                edit: "adminFoodMixe",
                new: "adminNewFoodMix",
            },
            site: {
                list: "foodMixes",
            },
            tank: {
                list: "foodMixes",
                new: "foodMix",
            },
        },
        model: "FoodMix",
        label: "foodMix",
        foreignKey: "idFoodMix",
        icon: faBowlFood,
        group: "growModel",
        index: 21
    },
    "FoodType": {
        routes: {
            admin: {
                list: "adminFoodTypes",
                edit: "adminFoodType",
                new: "adminNewFoodType",
            },
            site: {
                list: "foodTypes",
            },
            tank: {
                list: "foodTypes",
                new: "foodType",
            },
        },
        model: "FoodType",
        label: "foodType",
        foreignKey: "idFoodType",
        icon: faBowlFood,
        group: "growModel",
        index: 21
    },
    "ProbioticMix": {
        routes: {
            admin: {
                list: "adminProbioticMixes",
                edit: "adminProbioticMixe",
                new: "adminNewProbioticMix",
            },
            site: {
                list: "probioticMixes",
            },
            tank: {
                list: "probioticMixes",
                new: "probioticMix",
            },
        },
        model: "ProbioticMix",
        label: "probioticMix",
        foreignKey: "idProbioticMix",
        icon: faPrescriptionBottleMedical,
        group: "growModel",
        index: 21
    },
    "ProbioticType": {
        routes: {
            admin: {
                list: "adminProbioticTypes",
                edit: "adminProbioticType",
                new: "adminNewProbioticType",
            },
            site: {
                list: "probioticTypes",
            },
            tank: {
                list: "probioticTypes",
                new: "probioticType",
            },
        },
        model: "ProbioticType",
        label: "probioticType",
        foreignKey: "idProbioticType",
        icon: faPrescriptionBottleMedical,
        group: "growModel",
        index: 21
    },

    "ProbioticMixOnProbioticType": {
        model: "ProbioticMixOnProbioticType",
        label: "probioticMixOnProbioticType",
        icon: faPrescriptionBottleMedical,
        group: "growModel",
        index: 30
    },
    "Alert": {
        routes: {
            admin: {
                list: "adminAlerts",
                edit: "adminAlert",
                new: "adminNewAlert",
            },
            site: {
                list: "alerts",
            },
            tank: {
                list: "alerts",
                new: "alert",
            },
        },
        model: "Alert",
        label: "alert",
        icon: faBell,
        group: "event",
        index: 21
    },
    "ShortcutUrl": {
        routes: {
            admin: {
                list: "adminShortcutUrls",
                edit: "adminShortcutUrl",
                new: "adminNewShortcutUrl",
            },
            site: {
                list: "shortcutUrls",
            },
            tank: {
                list: "shortcutUrls",
                new: "shortcutUrl",
            },
        },
        model: "ShortcutUrl",
        label: "shortcutUrls",
        icon: faFileExcel,
        group: "configuration",
        index: 21
    },
    "Modop": {
        routes: {
            admin: {
                list: "adminModops",
                edit: "adminModop",
                new: "adminNewModop",
            },
            site: {
                list: "modops",
            },
            tank: {
                list: "modops",
                new: "modop",
            },
        },
        model: "Modop",
        label: "modops",
        icon: faFilePdf,
        group: "configuration",
        index: 21
    },
    "TankControl": {
        routes: {
            admin: {
                list: "adminTankControls",
                edit: "adminTankControl",
                new: "adminNewTankControl",
            },
            site: {
                list: "tankControls",
            },
            tank: {
                list: "tankControls",
                new: "tankControl",
            },
        },
        model: "TankControl",
        label: "tankControl",
        icon: faToolbox,
        group: "action",
        index: 21
    },
    "Treshold": {
        routes: {
            admin: {
                list: "adminTresholds",
                edit: "adminTreshold",
                new: "adminNewTreshold",
            },
            site: {
                list: "tresholds",
            },
            tank: {
                list: "tresholds",
                new: "treshold",
            },
        },
        model: "Treshold",
        nameKey: "unit",
        label: "treshold",
        icon: faHighlighter,
        group: "configuration",
        index: 22
    },
    "ForecastColumn": {
        routes: {
            admin: {
                list: "adminForecastColumns",
                edit: "adminEditForecastColumn",
                new: "adminNewForecastColumn",
            },
        },
        model: "ForecastColumn",
        nameKey: "headerName",
        label: "forecastColumn",
        icon: faTableColumns,
        group: "configuration",
        index: 23
    },
    "Harvest": {
        routes: {
            admin: {
                list: "adminHarvests",
                edit: "adminHarvest",
                new: "adminNewHarvest",
            },
            site: {
                list: "siteHarvest",
            },
            tank: {
                list: "harvests",
                new: "harvest",
            },
        },
        model: "Harvest",
        label: "harvest",
        icon: faBoxesStacked,
        group: "harvest",
        index: 23
    },
    "CalibrationTest": {
        routes: {
            admin: {
                list: "adminCalibrationTests",
                edit: "adminCalibrationTest",
                new: "adminNewCalibrationTest",
            },
            site: {
                list: "calibrationTest",
            },
            tank: {
                list: "calibrationTests",
                new: "calibrationTest",
            },
        },
        model: "CalibrationTest",
        label: "calibrationTest",
        icon: faRuler,
        group: "harvest",
        index: 24
    },
    "CaliberType": {
        routes: {
            admin: {
                list: "adminCaliberTypes",
                edit: "adminCaliberType",
                new: "adminNewCaliberType",
            },
            site: {
                list: "caliberType",
            },
            tank: {
                list: "caliberTypes",
                new: "caliberType",
            },
        },
        model: "CaliberType",
        label: "caliberType",
        icon: faRuler,
        group: "harvest",
        index: 24
    },
    "Packaging": {
        routes: {
            admin: {
                list: "adminPackagings",
                edit: "adminPackaging",
                new: "adminNewPackaging",
            },
            site: {
                list: "packaging",
            },
            tank: {
                list: "packagings",
                new: "packaging",
            },
        },
        model: "Packaging",
        label: "packaging",
        icon: faBoxArchive,
        group: "harvest",
        index: 25
    },
    "PackageType": {
        routes: {
            admin: {
                list: "adminPackageTypes",
                edit: "adminPackageType",
                new: "adminNewPackageType",
            },
            site: {
                list: "packageType",
            },
            tank: {
                list: "packageTypes",
                new: "packageType",
            },
        },
        model: "PackageType",
        label: "packageType",
        icon: faBoxArchive,
        group: "harvest",
        index: 26
    },
    "StorageType": {
        routes: {
            admin: {
                list: "adminStorageTypes",
                edit: "adminStorageType",
                new: "adminNewStorageType",
            },
            site: {
                list: "storageType",
            },
            tank: {
                list: "storageTypes",
                new: "storageType",
            },
        },
        model: "StorageType",
        label: "storageType",
        icon: faSnowflake,
        group: "harvest",
        index: 26
    },
    "OffMarketSort": {
        routes: {
            admin: {
                list: "adminOffMarketSorts",
                edit: "adminOffMarketSort",
                new: "adminNewOffMarketSort",
            },
            site: {
                list: "offMarketSort",
            },
            tank: {
                list: "offMarketSorts",
                new: "offMarketSort",
            },
        },
        model: "OffMarketSort",
        label: "offMarketSort",
        icon: faFilter,
        group: "harvest",
        index: 27
    },
    "SortType": {
        routes: {
            admin: {
                list: "adminSortTypes",
                edit: "adminSortType",
                new: "adminNewSortType",
            },
            site: {
                list: "sortType",
            },
            tank: {
                list: "sortTypes",
                new: "sortType",
            },
        },
        model: "SortType",
        label: "sortType",
        icon: faInbox,
        group: "harvest",
        index: 27
    },
    "SubSortType": {
        routes: {
            admin: {
                list: "adminSubSortTypes",
                edit: "adminSubSortType",
                new: "adminNewSubSortType",
            },
            site: {
                list: "subSortType",
            },
            tank: {
                list: "subSortTypes",
                new: "subSortType",
            },
        },
        model: "SubSortType",
        label: "subSortType",
        icon: faInbox,
        group: "harvest",
        index: 27
    },
    "ShrimpWeighing": {
        model: "ShrimpWeighing",
        label: "shrimpWeighing",
        icon: faWeightScale,
        group: "harvest",
        index: 28
    },
    
    "HarvestReport": {
        model: "HarvestReport",
        label: "harvestReport",
        icon: faClipboardCheck,
        group: "harvest",
        index: 29
    },
    "DetailBySortType": {
        model: "DetailBySortType",
        label: "detailBySortType",
        icon: faCheck,
        group: "harvest",
        index: 29
    },
    "DetailByCaliberType": {
        model: "DetailByCaliberType",
        label: "detailByCaliberType",
        icon: faCheck,
        group: "harvest",
        index: 29
    },
    "DetailBySubSortType": {
        model: "DetailBySubSortType",
        label: "detailBySubSortType",
        icon: faCheck,
        group: "harvest",
        index: 29
    },
    "ChangeDataCapture": {
        model: "ChangeDataCapture",
        label: "changeDataCapture",
        icon: faClipboardCheck,
        group: "configuration",
        index: 30
    },
    "FoodMixOnFoodType": {
        model: "FoodMixOnFoodType",
        label: "foodMixOnFoodType",
        icon: faBowlFood,
        group: "configuration",
        index: 30
    },
}

export const MODELS: Model[] = Object.values(MODELS_OBJECT).sort((a, b) => a.index - b.index);

export const MODELS_ACTIONS_ANALYSES = [
    "Feeding",
    "WaterBalance",
    "Settling",
    "Knackery",
    "WaterTransfer",
    "BatchTransfer",
    "TankControl",
    "Seeding",
    "BiometricAnalysis",
    "ObservationalAnalysis",
    "PhysicochemicalAnalysis",
    "MicrobiologicalAnalysis",
    "WaterAnalysis",
    "BatchInitial",
    "Harvest",
    "Event",
    "BatchReport",
]
export default MODELS;